import React, { useMemo } from 'react'

import { HHFormSelectField } from 'components/form-fields/v5'
import T from 'T'

import { buildContainerLabel } from '../exception-card/ExceptionContainerChip'

import { EXCEPTION_FORM_FIELD, EXCEPTION_TARGET_WORK_ORDER } from './constants'

import type { WorkOrderContainer } from '../../containers/types'
import type { ExceptionFormValues } from './constants'
import type { Control } from 'react-hook-form'

// "Exception for" selector on create: the whole work order ('' value) or one of its
// containers — drives workOrderContainerId on the create payload.
type ExceptionTargetSelectProps = {
  control: Control<ExceptionFormValues>
  containers?: WorkOrderContainer[]
}

// "<name> - <size> - <serial#>" so containers are identifiable at a glance in the dropdown;
// falls back to the positional "Container #N" when the container carries none of those.
const buildTargetOptionLabel = (container: WorkOrderContainer, index: number): string => {
  const name = container.name || container.containerName || ''
  const label = [name, buildContainerLabel(container)].filter(Boolean).join(' - ')
  return label || `${T.CONTAINER} #${index + 1}`
}

const ExceptionTargetSelect: React.FC<ExceptionTargetSelectProps> = ({ control, containers = [] }) => {
  const options = useMemo(
    () => [
      { key: 'work-order', value: EXCEPTION_TARGET_WORK_ORDER, label: T.WORK_ORDER },
      ...containers.map((container, index) => ({
        key: container.id,
        value: container.id,
        label: buildTargetOptionLabel(container, index),
      })),
    ],
    [containers]
  )

  return (
    <HHFormSelectField
      fullWidth
      control={control}
      deprecatedLabel={false}
      label={T.EXCEPTION_TARGET}
      name={EXCEPTION_FORM_FIELD.WORK_ORDER_CONTAINER_ID}
      options={options}
    />
  )
}

export default ExceptionTargetSelect
